import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_BlacklistEditor = _resolveComponent("BlacklistEditor")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_row = _resolveComponent("v-row")
  const _component_v_form = _resolveComponent("v-form")
  const _component_v_card = _resolveComponent("v-card")
  const _component_v_dialog = _resolveComponent("v-dialog")

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.isVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.isVisible) = $event)),
    "max-width": "30%",
    "onClick:outside": _ctx.cancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "pa-5",
        height: "max-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.blacklistEntryId ? "Edit entry" : "Create new entry"), 1),
          _createVNode(_component_v_form, {
            class: "mt-1",
            ref: "form",
            onSubmit: _withModifiers(_ctx.submit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BlacklistEditor, {
                "blacklist-model": _ctx.currentBlacklistModel,
                "onUpdate:blacklistModel": _cache[0] || (_cache[0] = $event => ((_ctx.currentBlacklistModel) = $event))
              }, null, 8, ["blacklist-model"]),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    class: "mr-3",
                    type: "submit"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.blacklistEntryId ? "Edit" : "Create"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "red",
                    onClick: _ctx.cancel
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("Cancel", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onClick:outside"]))
}